import $ from 'jquery';
import BasePropertyView from 'BasePropertyView'
import formatTemplate from 'properties/main/button-type.ejs';
import themeService     from 'ThemeService';

class MainButtonTypeView extends BasePropertyView {

    initialize( opts ) {

        super.initialize( opts );
        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.config = opts.config || {};


        this.events = {
            'change #buttonStyle' : 'updateSelectAttributes'
        };

        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();

        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        this.model.set( propName, propVal );
    }

    updateSelectAttributes(ev) {
        ev.preventDefault();

        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        this.model.set( propName, propVal );

        this.updateCombo();
    }

    render() {
        super.render();
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.updateForm();
        this.delegateEvents();
        this.updateCombo();

        return this;
    }

    updateForm() {
        //set selected index to model value
        if(this.model.get('buttonStyle')) {

            if (this.isThemeProperty(this.model.get('buttonStyle'))) {
                $('#buttonStyle').find('option[value='
                    +themeService.resolve(this.model.get('buttonStyle'))+']').attr('selected', true);
            }
            else {
                $('#buttonStyle').find('option[value='
                    +this.model.get('buttonStyle')+']').attr('selected', true);
            }

        }

        if (this.config.disabled) {
            $('#buttonStyle').prop('disabled', 'disabled');
        }
    }

    updateCombo(){

        if(this.model.get('buttonStyle')==='rectangular'){
            $("#cornerRadius").parent().find("input.ui-autocomplete-input").autocomplete("option", "disabled", true).prop("disabled",true);
            $("#cornerRadius").parent().find("a.ui-button").button("disable");
        }else{
            $("#cornerRadius").parent().find("input.ui-autocomplete-input").autocomplete("option", "disabled", false).prop("disabled",false);
            $("#cornerRadius").parent().find("a.ui-button").button("enable");
        }
    }

}

export default MainButtonTypeView;